/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { connect } from 'react-redux';
import { getP, PropType as PolygotPropType } from 'redux-polyglot';
import {
  Layout, Spin, Row,
  Input, Modal, Col,
} from 'antd';
import _ from 'lodash';
import numbro from 'numbro';
import moment from 'moment';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import momentPlugin from '@fullcalendar/moment';
import { getAdUnit, getAdUnitPlaylists } from 'actions/adunits';
import {
  formatDwellTime, dayMap, intDayMap, formatNumber, formatPrice, formatDuration,
} from '../formatHelpers';
import StatValue from '../StatValue';

const { Content } = Layout;

const calculatePrice = (start, end, price, base) => {
  const duration = moment.duration(moment(end).diff(moment(start)));
  let multiplier = 0;
  if (base === 'minute') {
    multiplier = Math.ceil(duration.asMinutes());
  } else if (base === 'hour') {
    multiplier = Math.ceil(duration.asHours());
  } else if (base === 'day') {
    multiplier = Math.ceil(duration.asDays());
  } else if (base === 'week') {
    multiplier = Math.ceil(duration.asWeeks());
  } else if (base === 'month') {
    multiplier = Math.ceil(duration.asMonths());
  }
  return multiplier * price;
};

class ActiveSchedules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailsVisible: false,
      eventDetails: {},
    };
    this.calendarRef = React.createRef();
  }

  componentDidMount() {
    const { dispatch, placement } = this.props;
    dispatch(getAdUnitPlaylists(placement.data.adunit_id));
    dispatch(getAdUnit(placement.data.adunit_id));
  }

  componentWillReceiveProps(nextProps) {
    const { placement } = this.props;
    const { dispatch } = nextProps;
    const placementID = ((placement || {}).data || {}).id;
    const newPlacementID = ((nextProps.placement || {}).data || {}).id;
    if (placementID !== newPlacementID) {
      const newAdUnitId = ((nextProps.placement || {}).data || {}).adunit_id;
      dispatch(getAdUnitPlaylists(newAdUnitId));
      dispatch(getAdUnit(newAdUnitId));
    }
  }

  eventRender = (info) => {
    const { title, start, end } = info.event;
    const { price, timeBase } = info.event.extendedProps;
    const time = `${moment(start).format('LT')} - ${moment(end).format('LT')}`;
    if (price) {
      info.el.firstChild.innerText = `${title}\n ${time}\n${formatPrice(price)}/${timeBase}`;
      info.el.children[0].className = 'custom-event';
      return info.el;
    }
    info.el.firstChild.innerText = `${title}\n ${time}\n`;
    info.el.children[0].className = 'custom-event';
    return info.el;
  };

  @autobind
  handleCloseModal() {
    this.setState({ detailsVisible: false });
  }

  @autobind
  handleEventClick(info) {
    const { p } = this.props;
    const { price, timeBase } = info.event.extendedProps;
    // eslint-disable-next-line no-underscore-dangle
    const days = info.event._def.recurringDef.typeData.daysOfWeek;
    const details = {
      title: info.event.title,
      start: moment(info.event.start).format('LT'),
      end: moment(info.event.end).format('LT'),
      id: info.event.id,
      day: days.length === 7 ? p.tt('all') : intDayMap[days],
      price,
      timeBase,
    };
    this.setState({ eventDetails: details, detailsVisible: true });
  }

  @autobind
  renderEventModal(e) {
    const { p } = this.props;
    return (
      <div className="event-modal">
        <Row style={{ marginBottom: 10 }}>
          <div className="label event-detail-text" style={{ marginBottom: 10, color: 'rgba(0, 0, 0, 0.85)' }}>
            {p.tt('cms2.playlist')}
          </div>
          <Input disabled value={e.title} />
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col className="event-detail-text">{p.tt('event_days')}</Col>
        </Row>
        <Row>
          <Input disabled value={e.day} />
        </Row>
        <Row>
          <Col className="event-detail-text" span={12}>{p.tt('schedules.start_time')}</Col>
          <Col className="event-detail-text" span={12}>{p.tt('schedules.end_time')}</Col>
        </Row>
        <Row gutter={5}>
          <Col span={12}>
            <Input disabled value={e.start} />
          </Col>
          <Col span={12}>
            <Input disabled value={e.end} />
          </Col>
        </Row>
        {!!e.price && (
          <React.Fragment>
            <Row>
              <Col className="event-detail-text" span={24}>{p.tt('price')}</Col>
            </Row>
            <Row gutter={5}>
              <Col span={24}>
                <Input
                  className="cms-price-add-on"
                  addonBefore="$"
                  disabled
                  value={`${numbro(e.price).format('0,0.00')}/${e.timeBase}`}
                />
              </Col>
            </Row>
          </React.Fragment>
        )}
      </div>
    );
  }

  @autobind
  renderNoSchedules() {
    const { p } = this.props;
    return (
      <div stylee={{ color: '#656872', fontSize: 13 }}>
        {p.t('noad_schedules')}
      </div>
    );
  }

  @autobind
  renderPurchaseStats() {
    const { p, adUnit } = this.props;
    return !!adUnit.data && (
      <div className="purchase-stats">
        <div className="flex-space-between-container">
          <Col span={12}>
            <StatValue
              title={p.tt('cms.displays')}
              value={formatNumber(adUnit.data.displays.length.toString())}
              displays={adUnit.data.displays}
            />
          </Col>
          <Col span={12}>
            <StatValue
              title={p.tt('ad_duration')}
              value={formatDuration(moment
                .utc(adUnit.data.duration * 1000).format('HH:mm:ss'))}
            />
          </Col>
        </div>
        <div className="flex-space-between-container">
          <Col span={12}>
            <StatValue
              title={p.tt('avg_dwell_time')}
              value={adUnit.data.dwell_time
                ? formatDwellTime(adUnit.data.dwell_time) : p.t('inventory.na')}
            />
          </Col>
          <Col span={12}>
            <StatValue
              title={p.tt('avg_daily_headcount')}
              value={adUnit.data.headcount
                ? numbro(Math.round(adUnit.data.headcount)).format('0,0') : p.t('inventory.na')}
            />
          </Col>
        </div>
      </div>
    );
  }

  @autobind
  renderAdBox() {
    const { p, placement } = this.props;
    const currentPlacement = (placement || {}).data;
    const { start_time: start, end_time: end, adunit } = currentPlacement;
    const price = currentPlacement.start_time
      ? calculatePrice(moment(start).format(), moment(end).format(),
        adunit.price, adunit.time_base)
      : 0;
    const dateRange = `${moment(start).format('L')} - ${moment(end).format('L')}`;
    return (
      <div className="purchase-box">
        <div className="purchase-dates">
          <Row gutter={2}>
            <Col span={24}>
              <div className="purchase-label">
                {`${p.tt('datepicker.date_range')}:`}
              </div>
              <Input disabled value={dateRange} />
            </Col>
          </Row>
        </div>
        {this.renderPurchaseStats()}
        <div className="purchase-button-container">
          <div className="price-container">
            <div className="price-sub-container">
              <Col span={12}>
                <div className="price-title">{p.tt('price')}</div>
                <div className="price-title" style={{ marginTop: '0.5em' }}>{p.tt('total')}</div>
              </Col>
              <Col span={12}>
                <div className="price-value">
                  {formatPrice(adunit.price)}
                  /
                  {adunit.time_base}
                </div>
                <div className="price-value">
                  {formatPrice(price)}
                </div>
              </Col>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLoading() {
    return (
      <Layout className="layout-loading">
        <Spin size="large" />
      </Layout>
    );
  }

  render() {
    const {
      adUnitPlaylists, adUnit, match, placement,
    } = this.props;
    const { eventDetails, detailsVisible } = this.state;
    if (
      (!adUnitPlaylists.data.length && adUnitPlaylists.pending)
      || (!placement.data && placement.pending)
      || (!adUnit.data)
      || placement.data.id !== parseInt(match.params.id, 10)
    ) {
      return this.renderLoading();
    }
    const selectedPlaylists = (adUnitPlaylists || {}).data;
    const selectedSchedules = _.flatten(selectedPlaylists.map(x => x.schedule || []));

    const uniqueSchedules = _.uniqBy(selectedSchedules, 'id').map((u) => {
      const title = (selectedPlaylists.find(y => y.id === u.playlist_id) || { name: '' }).name;
      return {
        title,
        startTime: u.start_time,
        endTime: u.end_time,
        daysOfWeek: Array.isArray(dayMap[u.day_of_week])
          ? [...dayMap[u.day_of_week]]
          : [dayMap[u.day_of_week]],
        id: u.id,
        playlist_id: u.playlist_id,
        color: '#18B8BE',
        price: adUnit.data.price,
        timeBase: adUnit.data.time_base,
      };
    });
    const scrollTime = uniqueSchedules.length ? uniqueSchedules[0].startTime : undefined;
    return (
      <Layout style={{ background: '#fff' }}>
        <Content>
          {!uniqueSchedules.length && this.renderNoSchedules()}
          <div className="purchase-calendar-container">
            <div className="flex-purchase-calendar">
              <div className="demo-app">
                <div className="demo-app-calendar">
                  <FullCalendar
                    defaultView="timeGridWeek"
                    header={{
                      left: '',
                      center: '',
                      right: '',
                    }}
                    plugins={[dayGridPlugin, timeGridPlugin, momentPlugin]}
                    ref={this.calendarRef}
                    events={uniqueSchedules}
                    firstHour={8}
                    columnHeaderFormat={{ weekday: 'long' }}
                    eventTimeFormat={{
                      hour: '2-digit',
                      minute: '2-digit',
                      meridiem: true,
                    }}
                    eventClick={this.handleEventClick}
                    eventRender={this.eventRender}
                    scrollTime={scrollTime}
                  />
                </div>
              </div>
            </div>
            <div className="flex-purchase-ad-box">
              <div>
                {this.renderAdBox()}
              </div>
            </div>
          </div>
          {eventDetails && (
            <Modal
              visible={detailsVisible}
              title=""
              onOk={this.handleCloseModal}
              onCancel={this.handleCloseModal}
              cancelButtonProps={{
                style: {
                  display: 'none',
                },
              }}
              width={400}
            >
              {detailsVisible && this.renderEventModal(eventDetails)}
            </Modal>
          )}
        </Content>
      </Layout>
    );
  }
}

ActiveSchedules.propTypes = {
  p: PolygotPropType,
  dispatch: PropTypes.func,
  adUnitPlaylists: PropTypes.object,
  adUnit: PropTypes.object,
  match: PropTypes.object,
  placement: PropTypes.object,
};

export default connect(state => ({
  p: getP(state),
  adUnitPlaylists: state.adUnitPlaylists,
  adUnit: state.adUnit,
}))(ActiveSchedules);
